import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../Layout/HomeLayout'
import HomeHeader from '../../../CustomComponents/HomeHeader'
import DynamicCard from '../../../CustomComponents/DynamicComponent/DynamicCard.js'
import { useTranslation } from 'react-i18next'
import Loader from '../../../CustomComponents/Loader'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { convertTimestamp, modifyHtmlForNavigation, retrieveData, useNotificationNavigation } from '../../../../utils'
import unread from "../../../../assets/images/unread.png"
import threeDots from "../../../../assets/images/Ellipses Large3_dots.png"
import { GetApiHeadersWithBearer, PostRequest } from '../../../../network/NetworkUtils'
import { NOTIFICATION_READ_ALERTS, NOTIFICATION_UNREAD_ALERTS, STATUS_SUCCESS_CODE } from '../../../../network/URLConstants'
import { appTheme } from '../../../../helpers/utils/Utils.js'
import { useDispatch } from 'react-redux'
import Modal from 'components/CustomComponents/Modal'
import Dollor_Tick from '../../../../assets/images/success.png'
import smiErrorImg from '../../../../assets/smi-kudzu-images/smi_mobile_error.png'

const SMINotificationItemCard = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const id = params.id;

    const [isLoading, setIsLoading] = useState(false);
    const [isShowDropdown, setIsShowDropdown] = useState(false);
    const [isUnread, setIsUnread] = useState(false);
    const [isReadActive, setIsReadActive] = useState(false);
    const [isUnReadActive, setIsUnReadActive] = useState(false);
    const selectedTab = useSelector(state => state.selectedNotificationTab);

    const notificationNavigation = useNotificationNavigation();

    const notifications = useSelector(state => state.notifications)
    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));

    const notificationItem = notifications.filter((item) => item.ID.toString() === id);

    const { Content, CreatedDateTime, AlertTypeCode, Unread, ID } = notificationItem[0];

    const timeStamp = convertTimestamp(CreatedDateTime);
    const modifiedContent = modifyHtmlForNavigation(Content, '#2965FB', isUnread);
    // console.log("modifiedContent", modifiedContent);
     debugger
    const markAsUnreadFun = async () => {
        try {
            setIsLoading(true);
            const AlertId = [ID]

            const deviceId = await retrieveData('updatedDeviceId')
            const cardKey = cards !== null
      ? cards.find((card) =>
          selectedTab === "Kudzu"
            ? card.AccountTypeBit63 === 64
            : card.AccountTypeBit63 === 1
        ).CardKey
      : 0; //

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const body = {
                cardKey: cardKey,
                AlertIds: AlertId,
            };
            const url = NOTIFICATION_UNREAD_ALERTS;
            const response = await PostRequest(url, body, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                // fetchNotifications(true, true);

            }

        } catch (error) {
        }

    }
    const markAsReadFun = async () => {
        try {
            setIsLoading(true);
            const AlertId = [ID]

            const deviceId = await retrieveData('updatedDeviceId')
            const cardKey = cards !== null
      ? cards.find((card) =>
          selectedTab === "Kudzu"
            ? card.AccountTypeBit63 === 64
            : card.AccountTypeBit63 === 1
        ).CardKey
      : 0; //

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const body = {
                cardKey: cardKey,
                AlertIds: AlertId,
            };
            debugger
            const url = NOTIFICATION_READ_ALERTS;
            const response = await PostRequest(url, body, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
            }

        } catch (error) {
        }

    }

    useEffect(() => {
        markAsReadFun();
    }, [])

    const handleUnreadClick = () => {
        // setIsUnReadActive(prev => !prev)
        setIsUnread(true)
        markAsUnreadFun()
    }

    const handleReadClick = () => {
        // setIsReadActive(prev => !prev)
        setIsUnread(false)
        markAsReadFun();
    }

    const handleBackClick = () => {
        navigate('/notifications')
    }


       const HeadingStyles =
                "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
              const HeadingUpdatedStyles =
                "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]"
              const continueButtonClasses = `font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer  flex items-center`;
            
              const [activityDetected, setActivityDetected] = useState(false)
              const [displayErrorMessage , setDiplayErrorMessage] = useState('')
              const [displaySuccessMesg , setDisplaySuccessMsg] = useState('')
              const [errorModal , setErrorModal] = useState(false)
              const [isSuccess, setIsSuccess] = useState(false)
             
              const closeActivityDetectedModal = () => {
                 setActivityDetected(false)
              }
        
               const closeErorModal = () => {
                setErrorModal(false)
              }
        
              const backToHome = () => {
                navigate('/home')
              }
        
            const handleNotificationAction = async (callbackUrl) => {
                try {
                    setIsLoading(true);
                    const deviceId = await retrieveData('updatedDeviceId');
                    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
                    const response = await PostRequest(callbackUrl, {}, headers);
                    const responseJson = JSON.parse(response);
                    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                        setIsLoading(false);
                        setDisplaySuccessMsg(responseJson.Response.message)
                        setIsSuccess(responseJson.Response.isSuccess)
                        setActivityDetected(true);
                    } else {
                        setIsLoading(false);
                        setErrorModal(true);
                        var arrMessages = responseJson.Messages;
                        var message = arrMessages[0];
                        var displayText = message.DisplayText;
                        setDiplayErrorMessage(displayText)
                    }
                } catch (error) {
                    setIsLoading(false);
                }
            }
      

    const Headingcom = () => {
        return (
            <div className="relative">
                <div className="flex flex-row justify-between m-10">
                    <p className=' text-[var(--notificationItem-color)] font-hanken-grotesk font-[600] text-[16px] leading-[26px] sm:text-[15px] sm:leading-[23px] md:font-[500] md:text-[26px] md:leading-[36px] '>{t("notifications")}</p>
                    <div className="my-auto cursor-pointer">
                        <img src={appThemeData.threeDots} alt="Three Dots" onClick={() => setIsShowDropdown(prev => !prev)} />
                    </div>
                </div>
                {isShowDropdown &&
                    <div className=" absolute right-0 h-[57px] w-[160px] md:w-[185px] z-10 rounded-bl-[1rem]  bg-[var(--dropdownBg)]">
                        <div className=" flex flex-col cursor-pointer w-full h-full">
                            {/* UNREAD */}
                            {isUnread &&
                                <div className={` rounded-bl-[1rem] py-5 px-6 ${isReadActive ? 'text-[var(--back-connect-color)] bg-[var(--dropdownBgClick)]' : 'text-white  bg-[var(--dropdownBg)] '}`} onClick={handleReadClick}>
                                    <p className='font-hanken-grotesk font-[600] text-[12px] leading-[18px] sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[21px]'>{t("markAsRead")}</p>
                                </div>
                            }

                            {/* READ */}
                            {!isUnread &&
                                <div className={` rounded-bl-[1rem] py-5 px-6 ${isUnReadActive ? 'text-[var(--back-connect-color)] bg-[var(--dropdownBgClick)]' : 'text-white  bg-[var(--dropdownBg-inner)] '}`} onClick={handleUnreadClick}>
                                    <p className='font-hanken-grotesk font-[600] text-[12px] leading-[18px] sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[21px]'>{t("markAsUnread")}</p>
                                </div>
                            }

                        </div>
                    </div>

                }
            </div>

        )
    }

    const Footer = () => {
        return (
            <div className=" flex justify-center items-center w-full my-16 mt-8">
                <div className=" flex justify-start w-[80%]">
                    <p className='font-hanken-grotesk font-[600]
                 text-[12px] leading-[20px] lg:font-[700] 
                 lg:text-[16px] lg:leading-[16px] text-[var(--notificationBack)]
                  cursor-pointer' onClick={handleBackClick}>
                        {t("back")}
                    </p>

                </div>
            </div>
        )
    }




    const children = () => {
        return (
            <div className=' flex flex-col my-10 gap-3 justify-center items-center pb-40'>
                <div className=' flex flex-row gap-4 w-[80%]'>
                    {isUnread &&
                        <div className='pt-2 w-[10px]'>
                            <img src={unread} className=' h-[10px] w-[10px]' alt="dot" />
                        </div>
                    }

                    <div className=' flex flex-col gap-3 w-[80%]'>
                        {/* <p className={`font-hanken-grotesk font-[500] text-[12px] leading-[18px] lg:text-[18px] lg:leading-[28px] text-[#262B3A] ${!Unread && 'opacity-75'}`}>
                            {Content}
                        </p> */}
                        <p className={`font-hanken-grotesk font-[600] md:text-[18px] md:leading-[27px] sm:text-[12px] sm:leading-[20px] text-[13px] leading-[19px] text-[var(--notificationText)] ${!isUnread && 'opacity-75'}`}>
                            <div
                                dangerouslySetInnerHTML={{ __html: modifiedContent }}
                                onClick={(e) => {
                                    const anchor = e.target.closest('a');
                                    if (anchor) {
                                          e.preventDefault();
                                        e.stopPropagation();
                                        const href = anchor.getAttribute('href');
                                        dispatch({
                                            type: 'CBK_TRANSACTIONS',
                                            payload: {
                                                notifications: [{ ...notificationItem[0] }]
                                            }
                                        });
                                        if (href && (href.startsWith('http://') || href.startsWith('https://')))
                                        {
                                            window.open(href, '_blank', 'noopener,noreferrer');
                                        }else if (href && (href === "yes-replace" || href === 'no-replace' || href === 'yes-unblock' || href === 'no-unblock')) {
                                                let action = null;
                                                if (href === "yes-replace") {
                                                  action = notificationItem[0].YesAction;
                                                } else if (href === 'no-replace') {
                                                  action = notificationItem[0].NoAction;
                                                } else if (href === 'yes-unblock') {
                                                  action = notificationItem[0].YesAction;
                                                }
                                                else if (href === 'no-unblock') {
                                                  action = notificationItem[0].NoAction;
                                                }

                                                if (action && action?.CallbackURL) {
                                                  handleNotificationAction(action?.CallbackURL)
                                                  return;
                                                }
                                        }else{
                                            notificationNavigation(href, e);
                                        }
                                    }
                                }}
                            />
                        </p>

                        <div className=' flex flex-row gap-2'>
                            {AlertTypeCode === "WRN" &&
                                <div className=' bg-footer rounded-full py-1 px-3'>
                                    <p className='font-hanken-grotesk font-[700] text-[9px] leading-[15px] md:text-[12px] md:leading-[18px] text-white'>
                                        {t("important")}
                                    </p>

                                </div>

                            }
                            <p className='font-hanken-grotesk font-[500] text-[12px] sm:font-[600]  sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[14px] 
                             text-[var(--timeStampText)] opacity-50'>
                                {timeStamp}
                            </p>

                        </div>
                    </div>

                </div>

                {/* ///unread */}

            </div>
        )
    }
    return (
        <HomeLayout>
            <HomeHeader heading={t("notification_heading")} isHeaderCaption={true} />
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight '>

                <DynamicCard
                    headerContent={Headingcom()}
                    cardHeight='auto]'
                    cardContent={children()}
                    footerContent={Footer()}
                    isWhite={appThemeData.isWhiteBgForCard}
                    isDarkForKudzu={appThemeData.isDarkBgForCard}
                />
            </div>

            {isLoading && <Loader />}

            {activityDetected && (
                                <Modal
                                  isOpen={activityDetected}
                                  onClose={closeActivityDetectedModal}
                                  defaultCornerRadius={false}
                                  isLogo={false}
                                  Fullheight={true}
                    title={<p className={HeadingUpdatedStyles}>
                        <span className={HeadingStyles}>
                            {
                                !isSuccess
                                    ? t('NTS_OOPS')
                                    : /\d/.test(displaySuccessMesg)
                                        ? ""
                                        : t('NTS_CONFIRMED')
                            }
                        </span>
                    </p>}
                                  subHeaderMsg={
                                    <span className={HeadingUpdatedStyles}>
                                    {displaySuccessMesg}
                                    </span>}
                                  content={
                                      <div className=' flex flex-col justify-center items-center w-full'>
                                          <div className="flex flex-col gap-20 justify-center mb-[0px]">
                                              <div className="flex flex-col justify-center items-center w-full">
            
                                              </div>
                                          </div>
                                          {
                                              !isSuccess ? (
                                                  <img
                                                      src={smiErrorImg}
                                                      alt="error"
                                                      className="lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10"
                                                  />
                                              ) : /\d/.test(displaySuccessMesg) ? (
                                                  <div className="flex flex-col gap-20 justify-center mb-[100px]">
                                                      <div className="flex flex-col justify-center items-center w-full">

                                                      </div>
                                                  </div>
                                              ) : (
                                                  <img
                                                      src={Dollor_Tick}
                                                      alt="complete"
                                                      className="lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10"
                                                  />
                                              )
                                          }
                                          <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                              <button class="font-hanken-grotesk mt-[40px] lg:text-[18px] md:text-[17px] 
                                               sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                              onClick={backToHome}
                                              >Home</button>
                                          </div>
                                      </div>
                                  }
                                />
                              )}
            
                        {errorModal && (
                            <Modal
                                isOpen={errorModal}
                                onClose={closeErorModal}
                                defaultCornerRadius={false}
                                isLogo={false}
                                Fullheight={true}
                                title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Oops!</span></p>}
                                subHeaderMsg={
                                    <span className={HeadingUpdatedStyles}>
                                        {displayErrorMessage}
                                    </span>}
                                content={
                                    <div className=' flex flex-col justify-center items-center w-full'>
                                        <div className="flex flex-col gap-20 justify-center mb-[20px]">
                                            <div className="flex flex-col justify-center items-center w-full">
            
                                            </div>
                                        </div>
                                        <img src={smiErrorImg} alt="complete" className='lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                                        <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                            <button class="font-hanken-grotesk mt-[40px] lg:text-[18px] md:text-[17px] 
                                               sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                            onClick={backToHome}
                                            >Home</button>
                                        </div>
                                    </div>
                                }
                            />
                        )}


        </HomeLayout >
    )
}

export default withOidcSecure(SMINotificationItemCard)